import { render, staticRenderFns } from "./fball-users.vue?vue&type=template&id=28e87ca8&scoped=true"
import script from "./fball-users.vue?vue&type=script&lang=js"
export * from "./fball-users.vue?vue&type=script&lang=js"
import style0 from "./fball-users.vue?vue&type=style&index=0&id=28e87ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e87ca8",
  null
  
)

export default component.exports